export default "__VITE_ASSET__DXlU2o2m__"